const { REACT_APP_API_URL = '' } = import.meta.env;

export async function fetchOwaspDemoConfig() {
    const res = await fetch(
        `${REACT_APP_API_URL}/public/owasp-training-demo/config`
    );
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        return { enabled: false };
    }
    return { enabled: !!data.enabled, settingKey: data.settingKey };
}

export async function generateOwaspModule(payload) {
    const res = await fetch(
        `${REACT_APP_API_URL}/public/owasp-training-demo/generate`,
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                framework: 'OWASP Top 10',
                language: 'en',
                ...payload,
            }),
        }
    );

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
        throw new Error(data.error || `Generation failed (${res.status})`);
    }

    return data;
}
